import React, { useEffect, useRef, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
// import './Main.css';
import './css.css'
import './components/Header.css'
import Banner from './Banner';
import MainLink from './MainLink';
import UserMenu from './components/UserMenu';
import { useUser } from './components/UserProvider';
import { navItems } from './Linklist';

const Main = () => {
  const location = useLocation();
  const activeItemRef = useRef(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isDarkMode, updateDarkMode } = useUser();

  // 다크모드 토글 함수
  const toggleDarkMode = async () => {
    const newDarkMode = !isDarkMode;
    
    // UserProvider의 updateDarkMode 함수 사용 (로그인 상태면 서버에도 업데이트)
    await updateDarkMode(newDarkMode);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // 7일 이내 업데이트 확인 함수
  const isRecentlyUpdated = (lastUpdated) => {
    if (!lastUpdated) return false;
    const updatedDate = new Date(lastUpdated);
    const today = new Date();
    const diffTime = Math.abs(today - updatedDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 7;
  };

  // 사이드바 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarOpen && !event.target.closest('.sidebar') && !event.target.closest('.sidebar-toggle')) {
        closeSidebar();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebarOpen]);

  return (
    <div className="App">
      {/* 사이드바 오버레이 */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      {/* 사이드바 */}
      <nav className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h2>RF4 데이터 사이트</h2>
          <button className="sidebar-close" onClick={closeSidebar} aria-label="메뉴 닫기">
            ×
          </button>
        </div>

        <ul className="sidebar-nav">
          {navItems.map(({ pagePath, label, icon, isUpdated, lastUpdated }, index) => {
            const isActive = location.pathname === pagePath;
            const showUpdateBadge = isUpdated && isRecentlyUpdated(lastUpdated);
            
            return (
              <li className={`sidebar-item ${isActive ? 'active' : ''}`} key={index} ref={isActive ? activeItemRef : null}>
                <Link to={pagePath} className="sidebar-link" onClick={closeSidebar}>
                  <div className="icon-wrapper">
                    <img src={icon} className="icon" alt={`${label.toLowerCase()} icon`} />
                    {showUpdateBadge && (
                      <span className="update-badge">업데이트</span>
                    )}
                  </div>
                  <span>{label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

        {/* 페이지 헤더 */}
        <header className={`app-header ${sidebarOpen ? 'sidebar-open' : ''}`}>
          <div className="app-header-content">
            {/* 사이드바 토글 버튼을 헤더 내부로 이동 */}
            <button 
              className={`sidebar-toggle ${sidebarOpen ? 'hidden' : ''}`} 
              onClick={toggleSidebar} 
              aria-label="메뉴 열기"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
            
            <div className="app-header-title-section">
              <Link to="/">
                <h1 className="app-site-title">RF4 데이터 사이트</h1>
              </Link>
            </div>
            <div className="app-header-user-section">
              <button 
                className="dark-mode-toggle"
                onClick={toggleDarkMode}
                aria-label={isDarkMode ? '라이트 모드로 전환' : '다크 모드로 전환'}
              >
                {isDarkMode ? '☀️' : '🌙'}
              </button>
              <UserMenu />
            </div>
          </div>
        </header>

        {/* 메인 페이지 콘텐츠 */}
        {location.pathname === '/' && (
          <main className="app-main-content">
            <Banner />
            <div style={{ paddingTop: '20px' }}>
              <MainLink />
            </div>
          </main>
        )}
    </div>
  );
};

export default Main;
